<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs"
               v-on="on"
               @click="switchover"
               icon>
          <v-icon v-if="getDarker">brightness_high</v-icon>
          <v-icon v-else>brightness_4</v-icon>
        </v-btn>
      </template>
      <span>{{ getDarker ? '标准模式' : '夜间模式' }}</span>
    </v-tooltip>

<!--    <v-tooltip bottom>-->
<!--      <template v-slot:activator="{ on, attrs }">-->
<!--        <v-btn v-bind="attrs"-->
<!--               :disabled="getDarker"-->
<!--               v-on="on"-->
<!--               @click="switchoverBackground"-->
<!--               icon>-->
<!--          <v-icon v-if="getBackground && !getDarker">image_not_supported</v-icon>-->
<!--          <v-icon v-else>image</v-icon>-->
<!--        </v-btn>-->
<!--      </template>-->
<!--      <span>{{ getBackground ? '取消背景' : '设置背景' }}</span>-->
<!--    </v-tooltip>-->

    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs"
               v-on="on"
               @click="showNotice"
               icon>
          <v-icon>update</v-icon>
        </v-btn>
      </template>
      <span>更新日志</span>
    </v-tooltip>

  </div>
</template>

<script>
import {mapGetters, mapMutations} from "vuex";

export default {
  name: "v-aside",
  data: () => ({
    resultData: [],
  }),
  computed: {
    ...mapGetters(['getDarker', 'getBackground'])
  },
  mounted() {
    this.dark();
  },
  methods: {
    ...mapMutations(['setDarker', 'setBackground', 'setBackground']),
    switchover() {
      this.setDarker(!this.getDarker)
      this.dark()
    },
    dark() {
      this.$vuetify.theme.dark = this.getDarker
    },
    switchoverBackground() {
      if (!this.getDarker) {
        this.setBackground(!this.getBackground)
      }
    },
    showNotice() {
      this.$router.push({
        path: '/notice/index',
        query: {keyword: this.keyword}
      })
    },
  }
}
</script>

<style scoped>

</style>
